import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { Popover } from '~/components/Popover';
import { cn } from '~/lib/cn';

import { ArtistContactInfo } from '../ArtistContactInfo/ArtistContactInfo';
import { chevron } from '../TrackDetails/components/DateRangePicker/DateRangePicker.styles';

interface ContactInfoPopoverProps {
  partyId: number;
}

export const ContactInfoPopover = ({ partyId }: ContactInfoPopoverProps) => {
  const { t } = useTranslation('roster');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      side="bottom"
      sideOffset={24}
      align="end"
      alignOffset={-140}
      onOpenChange={setIsOpen}
      content={<ArtistContactInfo partyId={partyId} />}
      stopPropagation
      triggerAsChild
    >
      <button
        aria-label={t('labels.contactInfo')}
        className="relative flex items-center gap-md rounded-full border py-xs pl-md pr-xl transition-colors border-emphasis-strong hover:bg-emphasis-subtle"
      >
        <span className="font-semibold text-white">
          {t('labels.contactInfo')}
        </span>
        <Icon
          className={cn(
            chevron({ state: isOpen ? 'open' : 'default' }),
            'right-sm',
          )}
          size="sm"
          type="chevron-down"
        />
      </button>
    </Popover>
  );
};

ContactInfoPopover.displayName = 'ContactInfoPopover';
